export default __webpack_public_path__ + "static/novade-logo-square-bea857615d766c698f2ce7fe07a6e7db.jpg";